// Set while a sign-up is finishing: the account exists, but the household is still being set up
// and the user hasn't been routed to onboarding yet. PublicRoute normally sends any signed-in
// visitor straight to /MealPlan; during this window it keeps showing the sign-up page instead,
// otherwise the meal planner flashes up before the onboarding screens.
//
// A module variable rather than storage on purpose: it only has to last a few seconds in this
// tab, and a reload mid-sign-up should fall back to the normal signed-in redirect.
let signupFinishing = false;

export function markSignupFinishing() {
  signupFinishing = true;
}

export function clearSignupFinishing() {
  signupFinishing = false;
}

export function isSignupFinishing() {
  return signupFinishing;
}

// Set when a fresh sign-up is routed to the plan screen; cleared when onboarding finishes. It tells
// the plan screen whether to run the full 3-step onboarding, or (for an existing owner sent there
// because they have no plan yet) start the trial straight away without re-asking Week start and
// Servings, which would overwrite preferences they already saved. sessionStorage so a reload
// mid-onboarding keeps it.
const ONBOARDING_KEY = 'mp:onboardingInProgress';

export function markOnboardingInProgress() {
  sessionStorage.setItem(ONBOARDING_KEY, '1');
}

export function clearOnboardingInProgress() {
  sessionStorage.removeItem(ONBOARDING_KEY);
}

export function isOnboardingInProgress() {
  return sessionStorage.getItem(ONBOARDING_KEY) === '1';
}
